module.exports = __webpack_public_path__ + "img/q5.bca29cad.png";